<script setup lang="tsx">
import { getCSSVar } from "@zyzgroup/core-web";

const props = withDefaults(
  defineProps<{
    width?: string;
    color?: string;
  }>(),
  {
    width: "10px",
    color: getCSSVar("--xg-blue")
  }
);
</script>

<template>
  <svg
    :style="['transform-origin: center', 'width: ' + props.width]"
    viewBox="0 0 7 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.153989 2.49994C-0.0513296 2.28468 -0.0513296 1.93567 0.153989 1.72041C0.359307 1.50514 0.692194 1.50514 0.897512 1.72041L3.12808 4.05902C3.3334 4.27428 3.3334 4.62329 3.12808 4.83855C2.92276 5.05382 2.58988 5.05382 2.38456 4.83855L0.153989 2.49994Z"
      :fill="props.color"
    />
    <path
      d="M6.10249 0.161447C6.30781 -0.0538159 6.64069 -0.0538157 6.84601 0.161447C7.05133 0.376711 7.05133 0.725721 6.84601 0.940984L3.12808 4.83855C2.92276 5.05382 2.58988 5.05382 2.38456 4.83855C2.17924 4.62329 2.17955 4.27439 2.38487 4.05913L6.10249 0.161447Z"
      :fill="props.color"
    />
  </svg>
</template>
